import { yaBukanFlagOptions } from '@/constants/flagAndCategory';
import { invoiceReminderStatusOptions } from '@/constants/status';

const headers = [
  { title: 'No. Reminder', key: 'code', sortable: true },
  { title: 'Tgl. Reminder', key: 'reminder_date', sortable: true },
  { title: 'Revisi', key: 'is_revision', sortable: true, align: 'center' },
  { title: 'Perusahaan', key: 'company_name', sortable: true },
  { title: 'Customer', key: 'customer_name', sortable: true },
  { title: 'Sisa Tagihan', key: 'due_amount', align: 'end', sortable: true },
  {
    title: 'Status',
    key: 'status',
    sortable: true,
    align: 'center',
  },
  { title: 'Created At', key: 'created_at', sortable: true },
  { title: 'Updated At', key: 'updated_at', sortable: true },
  { title: 'Actions', key: 'actions', sortable: false, align: 'center' },
];

const filters = [
  { title: 'No. Reminder', key: 'code', type: 'text' },
  { title: 'Tgl. Reminder (awal)', key: 'reminder_date_from', type: 'date' },
  { title: 'Tgl. Reminder (akhir)', key: 'reminder_date_to', type: 'date' },
  { title: 'Revisi', key: 'is_revision', type: 'select', selectOptions: yaBukanFlagOptions },
  { title: 'Perusahaan', key: 'company_name', type: 'text' },
  { title: 'Customer', key: 'customer_name', type: 'text' },
  {
    title: 'Status',
    key: 'status',
    type: 'select',
    selectOptions: invoiceReminderStatusOptions.map(({ value, title }) => ({ value, title })),
  },
];

export { filters, headers };
